import { useQuery } from "@apollo/client";
import React, { PropsWithChildren } from "react";
import { getViewer } from "types/gql-types";
import { apolloClient } from "data/graphql";
import { VIEWER_QUERY } from "components/auth/query";
import Context, { Login } from "./context";

const Provider: React.FC<PropsWithChildren<unknown>> = (props) => {
  const query = useQuery<getViewer>(VIEWER_QUERY);
  const { refetch } = query;

  // The implementation form is completed off-app (Formstack); refresh the viewer
  // on window focus so nav app-list gating reflects completion without a reload.
  React.useEffect(() => {
    const onFocus = () => refetch();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [refetch]);

  if (query.loading || !query.data) {
    return null;
  }

  return (
    <Login.Provider value={{ onLogin: () => {
      query.refetch();
      apolloClient.refetchQueries({ include: ["AppliedPropertyFeatures"] });
    } }}>
      <Context.Provider value={query.data.viewer}>{props.children}</Context.Provider>
    </Login.Provider>
  );
};

export default Provider;
